import { whenAll } from 'platform/shared/health-apps';
import content from '../../../locales/en/content.json';
import {
  hasDifferentMailingAddress,
  hasNoSharedAddress,
  hasSecondaryCaregiverOne,
  hasSecondaryCaregiverTwo,
} from '../../../utils/helpers';
import addressSelection from './addressSelection';
import contactInformation from './contactInformation';
import hasSecondaryTwo from './hasSecondaryTwo';
import homeAddress from './homeAddress';
import identityInformation from './identityInformation';
import mailingAddress from './mailingAddress';
import personalInformation from './personalInformation';

export const secondaryTwoPages = {
  hasSecondaryTwo: {
    path: 'secondary-caregiver/add-additional-caregiver',
    title: content['secondary-two-intro-title'],
    depends: hasSecondaryCaregiverOne,
    ...hasSecondaryTwo,
  },
  secondaryTwoPersonalInfo: {
    path: 'additional-secondary-caregiver/personal-information',
    title: content['secondary-two-info-title--personal'],
    depends: hasSecondaryCaregiverTwo,
    ...personalInformation,
  },
  secondaryTwoIdentityInfo: {
    path: 'additional-secondary-caregiver/identity-information',
    title: content['secondary-two-info-title--id'],
    depends: hasSecondaryCaregiverTwo,
    ...identityInformation,
  },
  secondaryTwoAddressSelection: {
    path: 'additional-secondary-caregiver-address-selection',
    title: content['secondary-two-address--selection-title'],
    depends: hasSecondaryCaregiverTwo,
    ...addressSelection,
  },
  secondaryTwoHomeAddress: {
    path: 'additional-secondary-caregiver/home-address',
    title: content['secondary-two-info-title--address-home'],
    depends: whenAll(
      hasSecondaryCaregiverTwo,
      hasNoSharedAddress('secondaryTwo'),
    ),
    ...homeAddress,
  },
  secondaryTwoMailingAddress: {
    path: 'additional-secondary-caregiver/mailing-address',
    title: content['secondary-two-info-title--address-mailing'],
    depends: whenAll(
      hasSecondaryCaregiverTwo,
      hasDifferentMailingAddress('secondaryTwo'),
    ),
    ...mailingAddress,
  },
  secondaryTwoContactInfo: {
    path: 'additional-secondary-caregiver/contact-information',
    title: content['secondary-two-info-title--contact'],
    depends: hasSecondaryCaregiverTwo,
    ...contactInformation,
  },
};
